import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import {
  common,
  auth,
  user,
  review,
  area,
  board,
  keyword,
  estimate,
  shop,
  xeronote,
  chat,
  dashboard,
  booking,
  internet,
  safeNumber,
  address,
  mobile,
  community,
  banner,
  search,
  product,
  promotion,
} from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    auth,
    user,
    review,
    area,
    board,
    keyword,
    estimate,
    shop,
    xeronote,
    chat,
    dashboard,
    booking,
    internet,
    safeNumber,
    address,
    mobile,
    community,
    banner,
    search,
    product,
    promotion,
  },
  plugins: [
    createPersistedState({
      paths: [
        'user.user',
        'keyword.section',
        'keyword.sections',
        'keyword.benefits',
      ],
      key: 'vuexStore',
      storage: window.sessionStorage,
    }),
  ],
});
